import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import FormUtils from "../../../../../../utils/form-utils.component";

@Component({
  selector: "field-set-calculated-default",
  templateUrl: "./field-set-calculated-default.component.html",
  styles: [],
})
export class FieldSetCalculatedDefaultComponent implements OnInit, OnChanges {
  @Input() public guides: any[];
  @Input() public allfields: any;
  @Input() public fields: any;
  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();
  @Input() public notifications: any[];
  @Input() public tags: any[];
  public visibleFields: any[];
  public visibleAllFields: any[];
  public visibleGuides: any[];
  public visibleNotifications: any[];
  public visibleTags: any[];

  public ngOnInit() {
    this.geanerateGuidesFormioIds();
    this.generateNotificationKeys();
    this.filterOptions();
  }

  public ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes.guides && changes.guides.currentValue) {
      this.guides = changes.guides.currentValue;
    }
    if (changes.allfields && changes.allfields.currentValue) {
      this.allfields = changes.allfields.currentValue;
    }
    this.geanerateGuidesFormioIds();
    this.filterOptions();
  }

  public geanerateGuidesFormioIds() {
    if (this.guides) {
      this.guides.forEach((guide) => {
        guide.formIoId = FormUtils.generateGuideIdFromTitle(guide.title);
      });
    }
  }

  public generateNotificationKeys() {
    if (this.notifications) {
      this.notifications.forEach((msg) => {
        msg.key = FormUtils.generateGuideIdFromTitle(msg.content);
        msg.inputType = "text";
      });
    }
  }

  public filterOptions() {
    this.visibleAllFields = this.allfields ? this.allfields.filter((field) => (field.inputType === this.fieldOptions.inputType || field.type === this.fieldOptions.inputType) && field.key !== this.fieldOptions.key) : [];
    this.visibleFields = this.fields ? this.fields.components.filter((field) => field.inputType === this.fieldOptions.inputType && field.key !== this.fieldOptions.key) : [];
    this.visibleGuides = this.guides ? this.guides.filter((guide) => FormUtils.convertDeterminantTypeToFieldType(guide.type) === this.fieldOptions.inputType) : [];
    this.visibleNotifications = this.notifications ? this.notifications.filter((msg) => msg.inputType === this.fieldOptions.inputType) : [];
    this.visibleTags = this.tags ? this.tags.filter((tag) => this.fieldOptions.inputType === "text") : [];
  }

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
